import { render, staticRenderFns } from "./OrderableItemComponentDataExcluded.vue?vue&type=template&id=1197b27c&"
import script from "./OrderableItemComponentDataExcluded.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemComponentDataExcluded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports